import React from "react";
import { Modal } from "react-bootstrap";
import styles from "./datafiltermodal.module.scss";
import IExternalFilterData from "../dataFilter/IExternalFilterData";
import DataFilter from "../dataFilter/DataFilter";
import IDataFilterDescriptor from "../dataFilter/IDataFilterDescriptor";
import { useTranslation } from "react-i18next";

interface Props {
  externalData?: IExternalFilterData<any>[];
  descriptors: IDataFilterDescriptor[];
  setDescriptors: React.Dispatch<React.SetStateAction<IDataFilterDescriptor[]>>;
  applyButtonOnClick?: () => void; //TODO povine
  resetButtonOnClick?: () => void; //TODO povine
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const DataFilterModal = (props: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // handlers
  const closeDialogHandler = () => {
    props.setShow(false);
  };

  // render
  return (
    <Modal
      show={props.show}
      onHide={closeDialogHandler}
      dialogClassName={styles.dialog}
      className={styles.modal}
      scrollable
    >
      <div className={styles.header}>
        <button
          type="button"
          className={`close ${styles.closeBtn}`}
          onClick={closeDialogHandler}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h5 className="mb-0">
          <span className="ml-2">{tLabels("dataFilterModal.title")}</span>
        </h5>
      </div>
      <div className={`modal-body ${styles.body}`}>
        <DataFilter
          descriptors={props.descriptors || []}
          setDescriptors={props.setDescriptors}
          externalData={props.externalData}
          applyButtonOnClick={props.applyButtonOnClick!}
          resetButtonOnClick={props.resetButtonOnClick!}
        />
      </div>
      <div className={`modal-footer ${styles.footer}`}>
        <button
          className="btn btn-outline-secondary"
          onClick={props.resetButtonOnClick!}
        >
          {tLabels("dataFilterModal.reset")}
        </button>

        <button className="btn btn-primary" onClick={props.applyButtonOnClick!}>
          {tLabels("dataFilterModal.apply")}
        </button>
      </div>
    </Modal>
  );
};

export default DataFilterModal;
